// config.js (Firebase v9 modular version)
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
 apiKey: "AIzaSyDVxAUbsVBMAvh913Vz0Mbj5Pas7cdR7Zk",
  authDomain: "grandfunded-55607.firebaseapp.com",
  databaseURL: "https://grandfunded-55607-default-rtdb.firebaseio.com",
  projectId: "grandfunded-55607",
  storageBucket: "grandfunded-55607.firebasestorage.app",
  messagingSenderId: "737737613482",
  appId: "1:737737613482:web:380c39dc2cbcd9beed30d3"
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Export the needed services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };

